import Header from "../components/Header";
import Banner1 from "../components/Banner/Banner1";
import Banner2 from "../components/Banner/Banner2";
import Banner3 from "../components/Banner/Banner3";
import Banner4 from "../components/Banner/Banner4";
import Banner5 from "../components/Banner/Banner5";

export default function Main() {
  return (
    <div>
      <Header />
      <Banner1 />
      <Banner2 />
      <Banner3 />
      <Banner4 />
      <Banner5 />
    </div>
  );
}
